module.exports = __webpack_public_path__ + "static/book-banner-d22cbb87c95a8f15c6645bd5755d34d9.png";